module.exports = __webpack_public_path__ + "static/media/calendar-icon.7e65f9c4.svg";